import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { catchError, map, of } from 'rxjs';

import { BFF_URL, WITH_CREDENTIALS } from '@valk-nx/core/lib/core';
import type { HALResponse } from '@valk-nx/core/lib/interfaces/hal.interface';

import type {
	AddressInterface,
	GetAddressInterface,
} from './postal-code.interface';

@Injectable({ providedIn: 'root' })
export class PostalCodeService {
	private readonly http = inject(HttpClient);
	private readonly url = inject(BFF_URL);
	private readonly withCredentials = inject<{
		withCredentials: boolean;
	}>(WITH_CREDENTIALS);

	getAddress({
		country,
		postalCode,
		houseNumber,
		houseNumberAddition,
	}: GetAddressInterface): Observable<Partial<AddressInterface>> {
		const headers = new HttpHeaders();
		const sanitizedPostalCode = postalCode.replaceAll(/\s/g, '');
		const addition = houseNumberAddition ? `/${houseNumberAddition}` : '';
		return this.http
			.get<
				HALResponse<AddressInterface>
			>(`${this.url}address/${country}/${sanitizedPostalCode}/${houseNumber}${addition}`, { ...this.withCredentials, headers, observe: 'response' })
			.pipe(
				map((response) => response.body?.data),
				map((data) => {
					return {
						...data,
						houseNumber: data?.houseNumber?.toString(),
					};
				}),
				catchError(() => of({})),
			);
	}
}
